var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    viewBox: "0 0 96 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 75C24 63.9543 34.7452 55 48 55C61.2548 55 72 63.9543 72 75M1 75C1 66.0515 11.623 53.2277 25 59.81M95 75C95 66.0515 84.377 53.2277 71 59.81M85.5 5.5V15.5M80.5 10.5H90.5M63 35C63 43.2843 56.2843 50 48 50C39.7157 50 33 43.2843 33 35C33 26.7157 39.7157 20 48 20C56.2843 20 63 26.7157 63 35ZM88 43C88 48.5228 83.5228 53 78 53C72.4772 53 68 48.5228 68 43C68 37.4772 72.4772 33 78 33C83.5228 33 88 37.4772 88 43ZM28 43C28 48.5228 23.5228 53 18 53C12.4772 53 8 48.5228 8 43C8 37.4772 12.4772 33 18 33C23.5228 33 28 37.4772 28 43ZM95 10.5C95 15.7467 90.7467 20 85.5 20C80.2533 20 76 15.7467 76 10.5C76 5.25329 80.2533 1 85.5 1C90.7467 1 95 5.25329 95 10.5Z",
    stroke: "#127CF5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrganization);
export default __webpack_public_path__ + "static/media/add-organization.ef8c2cd7231fa8c77c396e56509bc545.svg";
export { ForwardRef as ReactComponent };